export const Constants = Object.freeze({
    ENVIRONMENT: {
        DEVELOPMENT: 'http://localhost:8000',
        CLOCKOUT_TEST_API: 'https://tvfcu-test.joinclockout.com',
        CLOCKOUT_STAGING_API: 'https://staging.joinclockout.com',
        TVFCU_ENV: 'https://tvfcu-test.joinclockout.com'
    },
    CONSUMER_AUTH_TOKEN: 'fyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVaJ0',
});
